import React, { useState } from 'react'
import { AccordionProps } from './types'
import styles from './Accordion.module.scss'
import { MaterialSymbol } from '../MaterialSymbol'

export const StyledAccordion: React.FC<AccordionProps> = ({ title, children, defaultOpen = false, size = 'default', className }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  const onToggle = event => setIsOpen(event.target.open)
  const icon = isOpen ? 'remove' : 'add'
  const summarySizeClass = size === 'default' ? 'px-L py-XL text-M' : 'p-M text-XS'
  const childSizeClass = size === 'default' ? 'px-L py-XL text-M' : 'px-M pt-S pb-M text-XS'
  const iconAreaSizeClass = size === 'default' ? 'w-8 h-8' : 'w-6 h-6'
  const iconSize = size === 'default' ? '20px' : '14px'

  return (
    <details className={`border-t-1 border-b-1 border-member-gray-30 w-full ${styles.details} ${className ?? ''}`} open={defaultOpen} onToggle={onToggle}>
      <summary
      className={`list-none flex justify-between items-center gap-M text-member-gray-100 leading-6 font-bold hover:bg-member-gray-20 ${summarySizeClass}`}>
        <div>{title}</div>
        <div className={`flex justify-center items-center border-1 border-member-gray-30 rounded-full flex-shrink-0 ${iconAreaSizeClass}`}>
          <MaterialSymbol name={icon} className="text-member-green-100 font-bold" size={iconSize} />
        </div>
      </summary>
      <div className={`${childSizeClass} ${styles.content}`} style={{ lineHeight: '1.75' }}>
        {children}
      </div>
    </details>
  )
}
